import { cn } from "@/lib/utils";

type JorvioMarkProps = {
  className?: string;
};

/**
 * Jorvio mark — plain Latin J: stroked letter with a small entry curl and a pearl on the hook.
 * Intentionally minimal (no JQ monogram, motion, or extra chrome).
 */
export function JorvioMark({ className }: JorvioMarkProps) {
  const d =
    "M 8.35 6.15 Q 10.25 8 14.45 8.38 H 25.4 V 21.55 " +
    "C 25.4 28.65 20.85 31.85 15.9 31.85 C 12.35 31.85 9.55 30.35 8.05 27.65";

  return (
    <svg
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("text-primary-foreground", className)}
      aria-hidden
    >
      <path
        d={d}
        stroke="currentColor"
        strokeWidth={5.15}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={7.85} cy={27.35} r={2.25} fill="currentColor" />
    </svg>
  );
}
